var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('line-button'),_vm._v(" "),_c('oval-button'),_vm._v(" "),_c('freedraw-button')],1),_c('div',{staticClass:"player-and-drawer-container"},[_c('drawing-canvas')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }